import { formFieldsValidator } from './externalLinkForm'

export function validateForm<T = unknown>(fields: Record<keyof T, unknown>): boolean {
  return Object.keys(fields).every((key) => formFieldsValidator[key].isValid(fields[key].value))
}
